import {
  timestamp
} from "./chunk-QBXWAUJA.mjs";

// src/batching/send-event-batch/send-event-batch.ts
async function sendEventBatch(data, options = { debug: false, requestMode: "fetch" }) {
  return new Promise((resolve, reject) => {
    const { unix, microseconds } = timestamp();
    let payloadJsonString = JSON.stringify({
      context: data.payload.context,
      // Tech debt: golang unix timestamps are in seconds, not milliseconds. So we have to convert before sending to the API.
      events: data.payload.events.map((event) => ({ ...event, created: Math.floor(event.created / 1e3) })),
      sent: Math.floor(unix / 1e3),
      sentMicros: microseconds
    });
    switch (options.requestMode) {
      case "beacon":
        if (options.debug) {
          console.log("firing beacon with", payloadJsonString);
        }
        const beacon = navigator.sendBeacon(data.url, new Blob([payloadJsonString], { type: "application/json" }));
        resolve(beacon);
        break;
      case "fetch":
      default:
        fetch(data.url, {
          body: payloadJsonString,
          headers: {
            "Content-Type": "application/json"
          },
          keepalive: true,
          method: "POST"
        }).then((response) => {
          if (response.status < 300) {
            resolve(true);
          } else {
            reject(`Error: ${response.status} - ${response.statusText}`);
          }
        }).catch((error) => {
          if (options.debug) {
            console.error("Error(s) sending events:");
            console.dir(error, { depth: null });
          }
          reject(error);
        });
        break;
    }
  });
}

export {
  sendEventBatch
};
